import { getJson } from '../client'
import type { DateRange, PlateVisitsParams } from '../params'
import { API } from '../paths'
import {
  plateVisitsChartSchema,
  plateVisitsPageSchema,
  topPlatesSchema,
  vehiclesSummarySchema,
  type PlateVisitsChart,
  type PlateVisitsPage,
  type TopPlates,
  type VehiclesSummary,
} from '../schemas/vehicles'

/**
 * Реальные эндпоинты AZS API для «Потока автомобилей» (ТЗ п. 6), тег Plates. Период включительно
 * с обеих сторон. У бэкенда есть пресеты `period=day|week|month|year` (по умолчанию day), но границы
 * считает фронт, поэтому всегда шлём `period=custom` с явными from/to — чтобы пресет их не перекрыл.
 */
const CUSTOM = { period: 'custom' } as const

export const vehiclesApi = {
  getSummary: (params: DateRange): Promise<VehiclesSummary> =>
    getJson(API.plates.summary, vehiclesSummarySchema, { params: { ...CUSTOM, ...params } }),
  getTop: (params: DateRange): Promise<TopPlates> =>
    getJson(API.plates.top, topPlatesSchema, { params: { ...CUSTOM, ...params } }),
  getVisits: (params: PlateVisitsParams): Promise<PlateVisitsPage> =>
    getJson(API.plates.visits, plateVisitsPageSchema, { params: { ...CUSTOM, ...params } }),
  getChart: (params: DateRange): Promise<PlateVisitsChart> =>
    getJson(API.plates.chart, plateVisitsChartSchema, { params: { ...CUSTOM, ...params } }),
}
